"use client";

import { useEffect, useState } from "react";

/**
 * Renders children only after mount on the client. Use to avoid hydration
 * mismatches when the stack points into React/Next and the actual cause
 * is hard to isolate. Server sends a minimal shell; real content appears
 * after hydration so there is nothing to mismatch.
 */
export default function ClientOnly({
  children,
  fallback = null,
}: {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  if (!mounted) return <>{fallback}</>;
  return <>{children}</>;
}
